// 📰 THE POG TICKER — Times-Square marquee, now living on THE DEALS BOARD where billboards belong.
// Mode-aware: BIZ crawls deals + headlines, SPORTS crawls live scores, TRAVEL crawls trending trips.
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PogTicker = ({ businesses = [], onMerchant, mode = "biz" }) => {
  const navigate = useNavigate();
  const [ev, setEv] = useState(null);
  const [founding, setFounding] = useState(null);
  const [liveN, setLiveN] = useState(0);
  const [games, setGames] = useState([]);
  const [trips, setTrips] = useState([]);
  useEffect(() => {
    if (mode === "sports") {
      axios.get(`${API}/sports/scores`).then((r) => setGames(r.data.games || [])).catch(() => {});
      return;
    }
    if (mode === "travel") {
      axios.get(`${API}/travel/trending`).then((r) => setTrips(r.data.trending || [])).catch(() => {});
      return;
    }
    axios.get(`${API}/pog-events/next`).then((r) => setEv(r.data.event)).catch(() => {});
    axios.get(`${API}/superpog/founding`).then((r) => setFounding(r.data)).catch(() => {});
    axios.get(`${API}/live`).then((r) => setLiveN((r.data.lives || []).length)).catch(() => {});
  }, [mode]);
  const items = [];
  if (mode === "sports") {
    // 🍕 GAME DAY GRUB — tagged GAME DAY deals ride first, but ONLY while a real game is LIVE
    const liveGame = games.some((g) => g.state === "in");
    const grub = businesses
      .filter((b) => !b.ad_image_url && ((liveGame && b.game_day_deal) || (b.has_deals && ["bar_pub", "fast_food", "restaurants_food", "cafe_coffee", "liquor"].includes(b.category_id || ""))))
      .sort((a, b2) => (liveGame ? (b2.game_day_deal ? 1 : 0) - (a.game_day_deal ? 1 : 0) : 0))
      .slice(0, 4);
    let g = 0;
    games.slice(0, 10).forEach((gm, i) => {
      items.push({
        text: gm.state === "pre"
          ? `🏟 ${gm.away.abbr} @ ${gm.home.abbr} · ${gm.detail}`
          : `🏟 ${gm.away.abbr} ${gm.away.score} @ ${gm.home.abbr} ${gm.home.score} · ${gm.detail}`,
      });
      if ((i + 1) % 3 === 0 && grub[g]) {
        const b = grub[g++];
        items.push({ text: `🍕 GAME DAY GRUB: ${b.name} — deal inside`, tap: () => onMerchant?.(b), sup: true });
      }
    });
    if (items.length === 0) items.push({ text: "🏟 POG SPORTS — live scores crawl here on game day" });
  } else if (mode === "travel") {
    trips.slice(0, 6).forEach((t) => items.push({ text: `✈️ ${(t.dest || "").toUpperCase()} IS HOT — ${t.plans} POG'R${t.plans === 1 ? "" : "S"} planning this week`, tap: () => navigate("/travel") }));
    items.push({ text: "🧳 POG TRAVEL — flights, stays, cruises, bus, train & tours", tap: () => navigate("/travel") });
  } else {
    // ⚛️ ATOMIC POG apex headlines lead the crawl, then SUPER POG founding merchants
    businesses.filter((b) => b.atomic_pog && !b.ad_image_url).slice(0, 3)
      .forEach((b) => items.push({ text: `⚛️ ATOMIC POG: ${b.name} — APEX MERCHANT`, tap: () => onMerchant?.(b), sup: true }));
    businesses.filter((b) => b.super_pog && !b.atomic_pog && !b.ad_image_url).slice(0, 3)
      .forEach((b) => items.push({ text: `🚀 SUPER POG HEADLINE: ${b.name} — a FOUNDING merchant`, tap: () => onMerchant?.(b), sup: true }));
    businesses.filter((b) => b.has_deals && !b.ad_image_url).slice(0, 6)
      .forEach((b) => items.push({ text: `🔥 LIVE DEAL @ ${b.name}`, tap: () => onMerchant?.(b) }));
    if (ev) items.push({ text: `📅 NEXT POG EVENT: ${ev.emoji} ${ev.title} · ${new Date(ev.starts_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })} · 🔔 ${ev.marks} marked` });
    if (liveN > 0) items.push({ text: `🔴 ${liveN} POG LIVE stream${liveN === 1 ? "" : "s"} on the map RIGHT NOW`, tap: () => navigate("/reels") });
    if (founding) items.push({ text: `🏆 THE FOUNDING 100: ${founding.taken}/${founding.cap} SUPER POG slots taken`, tap: () => navigate("/founders") });
    items.push({ text: "🎯 JUST POG IT — deals, POGZ & events all around you" });
  }
  if (items.length === 0) return null;
  const seg = (k) => items.map((it, i) => (
    <button key={`${k}${i}`} data-testid="ticker-item" onClick={it.tap}
      className={`px-2 text-[11px] font-heading font-black tracking-wide whitespace-nowrap ${it.sup ? "text-fuchsia-300" : "text-amber-100"}`}>
      {it.text}&nbsp;&nbsp;&nbsp;✦
    </button>
  ));
  return (
    <>
      <style>{`@keyframes pogTickerCrawl{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
        .pog-ticker-track{display:inline-flex;white-space:nowrap;animation:pogTickerCrawl ${Math.max(18, items.length * 7)}s linear infinite}
        .pog-ticker-pill:hover .pog-ticker-track,.pog-ticker-pill:active .pog-ticker-track{animation-play-state:paused}`}</style>
      <div data-testid="pog-ticker" className="pog-ticker-pill w-full overflow-hidden rounded-xl border border-amber-400/30 bg-slate-900/80 shadow-[0_0_14px_rgba(251,191,36,0.12)]">
        <div className="pog-ticker-track py-1.5">
          {seg("a")}{seg("b")}
        </div>
      </div>
    </>
  );
};
